import React, { Component } from 'react';
import log from '../../helpers/logger';
import HtmlEditor from '../../components/custom/HtmlEditor';
import MultiFileUpload from '../../components/custom/MultiFileUpload';

import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';

export default class BlogList extends Component {
  constructor(props) {
    super(props);

    this.state = {

    }


  }

  componentDidMount() {

  }

  componentDidUpdate(prevprops, prevstates) { }

  render() {
    return (
      <div>
        <Container>
          <Row>
            <Col md={12}>
              <HtmlEditor htmlContent="<div>this is testing</div>" />
            </Col>
            <Col md={12}>
            <br />
            <br />
            <MultiFileUpload />
            </Col>
          </Row>
        </Container>

      </div>
    )
  }
};




// WEBPACK FOOTER //
// ./src/pages/CmnBlog/EditorTest.js